import React, { useState } from "react";
import {
  Modal,
  Form,
  Input,
  message,
  Upload,
  Button,
  Image,
  Select,
  Row,
  Col,
} from "antd";
import callApi from "../../constants/API/CallApi";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ShowToast, Severty } from "../../helper/toast";
import { addEmployee, ListBranch } from "../../constants/API/API";
import { uploadFileToS3 } from "../../helper/uploadImage";
import { UploadOutlined } from "@ant-design/icons";
import { emailDomainValidation } from "../../helper/functions";
import useApi from "../../hooks/useApi";

const FileType = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/avif",
  "image/webp",
  "image/gif",
];
const EmployeeAdd = ({ visible, setVisible, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [branches, setBranches] = useState([]);
  const [phone, setPhone] = useState({
    mobileNumber: "",
    countryCode: "",
  });

  const handleOk = async (values) => {
    setLoading(true);
    callApi({
      callback: addEmployee,
      payload: {
        ...values,
        ...phone,
        roleType: "employee",
        profilePic: file.length > 0 ? file[0].url : null,
      },
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        refresh(new Date().getTime());
        setVisible(false);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const validateName = (rule, value) => {
    if (!value) {
      return Promise.reject("Please enter a name");
    } else if (!/^[A-Z][a-zA-Z ]*$/.test(value)) {
      return Promise.reject(
        "Name must start with a capital letter and contain only letters"
      );
    } else {
      return Promise.resolve();
    }
  };

  const hide = () => {
    setVisible(false);
    form.resetFields();
  };

  const handleChangeMobileNumber = (value, country) => {
    const { dialCode } = country;
    const mobileNumber = value.slice(dialCode?.length);
    setPhone({
      mobileNumber: mobileNumber,
      countryCode: dialCode,
    });
  };

  useApi({
    callback: ListBranch,
    payload: { limit: 1000 },
    dependencies: [refresh],
    shouldCallApi: true,
    onSuccess: ({ list, totalDocs }) => {
      const activeBranches = (list || []).filter((branch) => branch.isActive);
      setBranches(activeBranches);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  return (
    <Modal
      open={visible}
      width={800}
      centered
      className="tab_modal"
      title="Add Employee"
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={handleOk} layout="vertical">
        <Row gutter={12}>
          <Col span={24} md={12}>
            <Form.Item
              name="name"
              label="Name"
              normalize={(v) => v?.trimStart()}
              rules={[{ required: true, validator: validateName }]}
            >
              <Input placeholder="Enter name" />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              name="role"
              label="Role"
              rules={[{ required: true, message: "Please select role!" }]}
            >
              <Select placeholder="Select Role Type">
                <Select.Option key={"branch"}>Branch Admin</Select.Option>
                <Select.Option key={"trainer"}>Trainer</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              name="branchId"
              label="Branch"
              rules={[{ required: true, message: "Please select branch!" }]}
            >
              <Select placeholder="Select Branch">
                {branches?.map((item) => {
                  return (
                    <Select.Option key={item?._id}>{item?.name}</Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: "Please enter the email" },
                {
                  type: "email",
                  message: "Please enter a valid email address",
                },
                // emailDomainValidation,
              ]}
              normalize={(v) => v?.trim()}
            >
              <Input placeholder="Enter email" />
            </Form.Item>
          </Col>
          <Col span={24} md={12}>
            <Form.Item
              name="mobileNumber"
              label="Mobile Number"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.reject(
                        new Error("Please enter the phone number")
                      );
                    }
                    if (value.length < 10) {
                      return Promise.reject(
                        new Error("Phone number must be at least 8-12 digits")
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <PhoneInput
                countryCode="91"
                countryCodeEditable={false}
                inputProps={{
                  name: "mobile",
                  required: true,
                  autoFocus: false,
                }}
                isValid={(value, country) => {
                  if (value.match(/1234/)) {
                    return "Invalid value: " + value + ", " + country.name;
                  } else if (value.match(/1234/)) {
                    return "Invalid value: " + value + ", " + country.name;
                  } else {
                    return true;
                  }
                }}
                country={"ca"}
                value={
                  phone
                    ? (phone.countryCode ? phone.countryCode : "+1") +
                      (phone.mobileNumber ? phone.mobileNumber : null)
                    : ""
                }
                onChange={handleChangeMobileNumber}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EmployeeAdd;
